module.exports = __webpack_public_path__ + "23bd3759acc2f988527e0f22f0a17516.svg";